(function () {
  function formatMoney(cents) {
    const value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  }

  function selectedPackCount(detail) {
    const subscribe = document.querySelector('bundle-subscribe');
    if (subscribe && typeof subscribe.selectedPackCount === 'function') {
      return subscribe.selectedPackCount(detail);
    }

    const fromDetail = Number(detail?.totalQuantity);
    if (Number.isFinite(fromDetail) && fromDetail > 0) {
      return Math.max(1, Math.round(fromDetail));
    }

    const fromBuilder = Number(window.BundleBuilder?.getTotalQuantity?.() || 0);
    if (fromBuilder > 0) return Math.max(1, Math.round(fromBuilder));

    const items = detail?.items || [];
    const sum = items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    return sum > 0 ? Math.max(1, Math.round(sum)) : 0;
  }

  function tierPricesFor(qty) {
    const subscribe = document.querySelector('bundle-subscribe');
    if (subscribe && typeof subscribe.tierPricesFor === 'function') {
      return subscribe.tierPricesFor(qty);
    }
    return null;
  }

  function syncButton(form, detail) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;

    const totals =
      detail?.totals ||
      window.BundleBuilder?.getTotals?.() || {
        hasItems: false,
        priceCents: 0,
        compareAtCents: 0,
      };

    const hasItems = Boolean(totals.hasItems || (detail?.items && detail.items.length));
    const showPrice = form.dataset.showPrice === 'true';

    const emptyEl = button.querySelector('[data-bundle-atc-empty]');
    const readyEl = button.querySelector('[data-bundle-atc-ready]');
    const compareEl = button.querySelector('[data-bundle-atc-compare]');
    const saleEl = button.querySelector('[data-bundle-atc-sale]');

    button.disabled = !hasItems;
    button.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
    button.classList.toggle('is-bundle-empty', !hasItems);
    button.classList.toggle('is-bundle-ready', hasItems);

    if (emptyEl) emptyEl.hidden = hasItems;
    if (readyEl) readyEl.hidden = !hasItems;

    if (!hasItems || !showPrice) return;

    const tier = tierPricesFor(selectedPackCount(detail));

    if (tier) {
      if (saleEl) saleEl.textContent = tier.price;
      if (compareEl) {
        const showCompare = Boolean(tier.compare) && tier.compare !== tier.price;
        compareEl.textContent = showCompare ? tier.compare : '';
        compareEl.hidden = !showCompare;
      }
      return;
    }

    const priceCents = Number(totals.priceCents) || 0;
    const compareCents = Number(totals.compareAtCents) || 0;

    if (saleEl) saleEl.textContent = formatMoney(priceCents);

    if (compareEl) {
      const showCompare = compareCents > priceCents;
      compareEl.textContent = showCompare ? formatMoney(compareCents) : '';
      compareEl.hidden = !showCompare;
    }
  }

  function init() {
    const forms = document.querySelectorAll('product-form[data-bundle-atc]');
    if (!forms.length) return;

    const onChange = (event) => {
      forms.forEach((form) => syncButton(form, event.detail));
    };

    document.addEventListener('bundle-builder:change', onChange);

    const initial = window.BundleBuilder
      ? {
          items: window.BundleBuilder.getItems(),
          totals: window.BundleBuilder.getTotals(),
          totalQuantity: window.BundleBuilder.getTotalQuantity(),
        }
      : { items: [], totals: { hasItems: false } };

    forms.forEach((form) => syncButton(form, initial));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
